import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/ZARA_Storages_Mall_of_Emirates.webp';

const Project_seventeen = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Zara Storages</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>A large-scale warehouse and storage facility for Zara — part of Inditex Group, the world's largest fashion retail group. The
                project required a complete turnkey MEP installation covering all mechanical, electrical, plumbing and fire protection systems.</p>
              <p>MAIN CONTRACTOR : ALEC</p>
              <p>MEP CONTRACTOR : -</p>
              <p>GEMCO SCOPE OF WORKS : Complete MEP supply and installation — mechanical,
                electrical, plumbing, firefighting and fire alarm systems</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_seventeen